import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=425a36ce&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=425a36ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a36ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('425a36ce')) {
      api.createRecord('425a36ce', component.options)
    } else {
      api.reload('425a36ce', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=425a36ce&scoped=true&", function () {
      api.rerender('425a36ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CZlkkF6eo63Y/JS/comp/DocBox.vue"
export default component.exports